import styled from 'styled-components'

const TimelineItemContainer = styled.div`
  display: flex;
  position: relative;
  margin-left: 0.75px;
`

export default TimelineItemContainer
